import { render } from "./editSignerComponent.vue?vue&type=template&id=92b784e6"
import script from "./editSignerComponent.vue?vue&type=script&lang=js"
export * from "./editSignerComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__